import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ImportHistory} from '../../models';
import {environment} from '~environments/environment';

/**
 * Service for calling the API as well as storing modalOpened data
 */
@Injectable({
  providedIn: 'root'
})
export class ImportsService {
  public API_URL: any = environment.envAPI;

  public importHistoryList: BehaviorSubject<Array<ImportHistory>> = new BehaviorSubject<Array<ImportHistory>>(null);
  public castImportHistoryList: any = this.importHistoryList.asObservable();

  constructor(private http: HttpClient) {
  }

  /**
   * Create a new address.
   */
  public postImportMedia(file: any): any {
    return this.http.post(`${this.API_URL}/import-media`, file);
  }

  /**
   * Create a new address.
   */
  public postImportRequest(data: any): any {
    return this.http.post(`${this.API_URL}/import-requests`, data);
  }

  /**
   * Get the import history endpoint.
   */
  public getImportHistoryEndpoint(clubId: number): any {
    const api = `${this.API_URL}/clubs/${clubId}/import-requests`;

    const params: Array<any> = [];

    return [api, params];
  }

  /**
   * Create the import history class.
   */
  public createImportHistoryClass(imports: Array<ImportHistory>): Array<ImportHistory> {
    return imports.map((el: ImportHistory) => new ImportHistory(el));
  }

  /**
   * Set a new import history list
   */
  public setImportHistoryList(importHistoryList: Array<ImportHistory>): void {
    this.importHistoryList.next(importHistoryList);
  }

}
